import { Typography } from "@circle-react/components/shared/uikit/Typography";
import type { Notification } from "@circle-react/types/Notification";

export interface SecondActorNameProps {
  notification: Notification;
}

export const SecondActorName = ({ notification }: SecondActorNameProps) => (
  <Typography.BodySm as="span" weight="font-semibold">
    {notification.second_actor_name}
  </Typography.BodySm>
);
